import { api } from "./useApi";
import {
  DadosDashboard,
  HistoricoVisitantes,
  HistoricoPedidos,
  HistoricoCupom,
  HistoricoEstados
} from "../types/Metricas";

export type {
  DadosDashboard,
  HistoricoVisitantes,
  HistoricoPedidos,
  HistoricoCupom,
  HistoricoEstados
};

export const metricasApi = () => ({
  getDadosDashboard: async (params?: {
    dias?: number;
    data_inicio?: string;
    data_fim?: string;
    id_usuario?: string;
  }): Promise<DadosDashboard> => {
    const response = await api.post("/empresa/dados_dash", params || {});
    return response.data;
  },

  // Novos endpoints modulares
  getResumo: async (params?: {
    dias?: number;
    data_inicio?: string;
    data_fim?: string;
    id_usuario?: string;
  }) => {
    const response = await api.post("/metricas/resumo", params || {});
    return response.data;
  },

  getHistoricoVisitantes: async (params?: {
    dias?: number;
    data_inicio?: string;
    data_fim?: string;
    id_usuario?: string;
  }): Promise<HistoricoVisitantes> => {
    const response = await api.post("/metricas/historico_visitantes", params || {});
    return response.data;
  },

  getHistoricoPedidos: async (params?: {
    dias?: number;
    data_inicio?: string;
    data_fim?: string;
    id_usuario?: string;
  }): Promise<HistoricoPedidos> => {
    const response = await api.post("/metricas/historico_pedidos", params || {});
    return response.data;
  },

  getHistoricoCupom: async (params?: {
    dias?: number;
    data_inicio?: string;
    data_fim?: string;
    id_usuario?: string;
  }): Promise<HistoricoCupom> => {
    const response = await api.post("/metricas/historico_cupom", params || {});
    return response.data;
  },

  getHistoricoEstados: async (params?: {
    dias?: number;
    data_inicio?: string;
    data_fim?: string;
    id_usuario?: string;
  }): Promise<HistoricoEstados> => {
    const response = await api.post("/metricas/historico_estados", params || {});
    return response.data;
  },
});
